<div class="preflight-modal">
	<div class="preflight-modal__header">
		<h2 class="fw-bold fs-xs">Dados incompletos</h2>
		<button mat-icon-button type="button" (click)="onCancel()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<p class="fs-xxs gray">
		Não foi possível comparar esta linha porque existem dados obrigatórios
		ausentes ou inválidos.
	</p>

	<div class="preflight-modal__summary">
		<div class="preflight-modal__summary-grid">
			<div class="preflight-info-card preflight-info-card--wide">
				<span>Beneficiário</span>
				<strong>{{ data.row.data?.beneficiaryName || '-' }}</strong>
			</div>
			<div class="preflight-info-card">
				<span>CPF informado</span>
				<strong>{{ data.row.data?.beneficiaryCpf || '-' }}</strong>
			</div>
			<div class="preflight-info-card">
				<span>Operadora informada</span>
				<strong>{{ data.row.data?.carrier || '-' }}</strong>
			</div>
		</div>
		<div class="preflight-modal__source" *ngIf="sourceLabel !== '-'">
			{{ sourceLabel }}
		</div>
		<div class="preflight-reasons">
			<span class="preflight-reasons__label">Motivo</span>
			<div class="preflight-reasons__chips">
				<span
					class="preflight-reason-chip"
					*ngFor="let label of issueLabelList"
				>
					{{ label }}
				</span>
			</div>
		</div>
	</div>

	<form class="preflight-modal__form" [formGroup]="form">
		<div class="preflight-modal__form-header">
			<h3 class="fs-xxs fw-bold">Corrigir dados da linha</h3>
			<p class="fs-xxxs gray">
				Preencha somente os campos necessários para liberar a comparação.
			</p>
		</div>
		<div class="preflight-modal__fields">
			<mat-form-field appearance="outline" *ngIf="shouldShowCpf">
				<mat-label>CPF</mat-label>
				<input matInput type="text" formControlName="cpf" />
			</mat-form-field>

			<mat-form-field appearance="outline" *ngIf="shouldShowCarrier">
				<mat-label>Operadora</mat-label>
				<input matInput type="text" formControlName="carrier" />
			</mat-form-field>
		</div>
		<p class="error-message fs-xxs" *ngIf="errorMessage">{{ errorMessage }}</p>
	</form>

	<div class="preflight-modal__actions">
		<div class="preflight-modal__actions-secondary">
			<button
				mat-stroked-button
				color="primary"
				type="button"
				(click)="onPlaceOnHold()"
			>
				Colocar em espera
			</button>
			<button
				mat-stroked-button
				color="warn"
				type="button"
				(click)="onIgnore()"
			>
				Ignorar
			</button>
			<button mat-stroked-button color="primary" type="button" disabled>
				Aplicar somente este
			</button>
		</div>
		<div class="preflight-modal__actions-primary">
			<button mat-flat-button color="primary" type="button" (click)="onSave()">
				Salvar na fila
			</button>
			<button
				mat-button
				color="warn"
				type="button"
				[disabled]="!data.pendingChange"
				(click)="onRemove()"
			>
				Remover da fila
			</button>
		</div>
	</div>
</div>
